import React, { useEffect } from "react";
import './login.css';
import AOS from "aos";
import "aos/dist/aos.css";

const Login = () => {

	useEffect(() => {
		window.scrollTo(0, 0);
	  }, []);

	  useEffect(() => {
		AOS.init();
		AOS.refresh();
	  }, []);
    return (
        <>
<div className="container-fluid login-bg">
		<div className="container-login100 ">
			<div className="wrap-login100">
				<div 
				data-aos="fade-right"
				className="login100-pic js-tilt">
					<img src="./images/login.png" alt="IMG"/>
				</div>

				<form 
				data-aos="fade-left"
				className="login100-form validate-form">
					<span className="login100-form-title">
						Member Login
					</span>

					<div className="wrap-input100 validate-input" data-validate="Valid email is required: ex@abc.xyz">
						<input className="input100" type="text" name="email" placeholder="Email" required/>
						<span className="focus-input100"></span>
						<span className="symbol-input100">
							<i className="fa fa-envelope" aria-hidden="true"></i>
						</span>
					</div>

					<div className="wrap-input100 validate-input" data-validate="Password is required">
						<input className="input100" type="password" name="pass" placeholder="Password"/>
						<span className="focus-input100"></span>
						<span className="symbol-input100">
							<i className="fa fa-lock" aria-hidden="true"></i>
						</span>
					</div>
					
					<div className="container-login100-form-btn">
						<button className="login100-form-btn" disabled>
							Login
						</button>
					</div>

					{/* <div className="text-center p-t-12">
						<span class="txt1">
							Forgot 
						</span>
						<a className="txt2" href="#" >
							 Username / Password?
						</a>
					</div> */}

					{/* <div class="text-center p-t-136">
						<a class="txt2" href="#">
							Create your Account
							<i class="fa fa-long-arrow-right m-l-5" aria-hidden="true"></i>
						</a>
					</div> */}
				</form>
			</div>
		</div>
	</div>
        </>
    )
}

export default Login